// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offerManagementMainDiv {
    width: 90%;
    margin-left: 36px;
    border-radius: 16px;
    border: 1px solid var(--Global-Neutral-Grey-500, #E6E6E6);
    background: #FFF;
    padding: 32px 36px
}

.offerDetails {
    color: var(--Global-Neutral-Grey-1000, #4F4D55) !important;
    font-family: Poppins !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 150% !important;
    text-transform: uppercase !important;
}

.offerDetailsOverviewHeading {
    color: var(--Global-Neutral-Grey-1100, #2D2B32) !important;
    font-family: Poppins !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: normal !important;
}

.offerDetailsOverviewContent {
    color: var(--Global-Neutral-Grey-1000, #4F4D55) !important;
    font-family: Poppins !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 600 !important;
    line-height: normal !important;
}

.displayFlexStyle {
    display: flex;
}

.overviewDivider.MuiDivider-root {
    margin: 32px 0px;
}

.overviewTable .MuiTableCell-root {
    width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/offerManagement/offerManagementOverview/offerManagementOverview.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;IACzD,gBAAgB;IAChB;AACJ;;AAEA;IACI,0DAA0D;IAC1D,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,0DAA0D;IAC1D,+BAA+B;IAC/B,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,0DAA0D;IAC1D,+BAA+B;IAC/B,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".offerManagementMainDiv {\n    width: 90%;\n    margin-left: 36px;\n    border-radius: 16px;\n    border: 1px solid var(--Global-Neutral-Grey-500, #E6E6E6);\n    background: #FFF;\n    padding: 32px 36px\n}\n\n.offerDetails {\n    color: var(--Global-Neutral-Grey-1000, #4F4D55) !important;\n    font-family: Poppins !important;\n    font-size: 14px !important;\n    font-weight: 600 !important;\n    line-height: 150% !important;\n    text-transform: uppercase !important;\n}\n\n.offerDetailsOverviewHeading {\n    color: var(--Global-Neutral-Grey-1100, #2D2B32) !important;\n    font-family: Poppins !important;\n    font-size: 14px !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n    line-height: normal !important;\n}\n\n.offerDetailsOverviewContent {\n    color: var(--Global-Neutral-Grey-1000, #4F4D55) !important;\n    font-family: Poppins !important;\n    font-size: 14px !important;\n    font-style: normal !important;\n    font-weight: 600 !important;\n    line-height: normal !important;\n}\n\n.displayFlexStyle {\n    display: flex;\n}\n\n.overviewDivider.MuiDivider-root {\n    margin: 32px 0px;\n}\n\n.overviewTable .MuiTableCell-root {\n    width: 50%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
